module.exports = __webpack_public_path__ + "static/virtualDOMNode-b0e899b3632f0313a5fba80652f38612.jpg";